export const DriversLicenseNumberConfig = {
  ACT: {
    maskPattern: {
      minLength: 9,
      maxLength: 9,
    },
    config: [
      {
        slug: 'pattern',
        configContext: { pattern: '^[A-Za-z0-9]{9}$' },
      },
    ],
  },
  NSW: {
    maskPattern: {
      minLength: 6,
      maxLength: 8,
    },
    config: [
      {
        slug: 'pattern',
        configContext: { pattern: '^[A-Za-z0-9]{6,8}$' },
      },
    ],
  },
  NT: {
    maskPattern: {
      minLength: 7,
      maxLength: 7,
    },
    config: [
      {
        slug: 'pattern',
        configContext: { pattern: '^[A-Za-z0-9]{7}$' },
      },
    ],
  },
  WA: {
    maskPattern: {
      minLength: 7,
      maxLength: 7,
    },
    config: [
      {
        slug: 'pattern',
        configContext: { pattern: '^[A-Za-z0-9]{7}$' },
      },
    ],
  },
  SA: {
    maskPattern: {
      minLength: 6,
      maxLength: 6,
    },
    config: [
      {
        slug: 'pattern',
        configContext: { pattern: '^[A-Za-z0-9]{6}$' },
      },
    ],
  },
  TAS: {
    maskPattern: {
      minLength: 7,
      maxLength: 7,
    },
    config: [
      {
        slug: 'pattern',
        configContext: { pattern: '^[A-Za-z0-9]{7}$' },
      },
    ],
  },
  QLD: {
    maskPattern: {
      minLength: 9,
      maxLength: 9,
    },
    config: [
      {
        slug: 'pattern',
        configContext: { pattern: '^[A-Za-z0-9]{9}$' },
      },
    ],
  },
  VIC: {
    maskPattern: {
      minLength: 9,
      maxLength: 9,
    },
    config: [
      {
        slug: 'pattern',
        configContext: { pattern: '^[A-Za-z0-9]{9}$' },
      },
    ],
  },
};
